import httpService from '@Utils/httpService';

const baseUrl = 'api/';

export default {
    getUnits(assetId) {
        return httpService.get({
            url: `${baseUrl}forge/inspections/units/${assetId}`
        });
    },
    getAvailableFilters(facilityId) {
        return httpService.get({
            url: `${baseUrl}InspectionDashboard/ADNOC/${facilityId}/AvailableFilters/v2`
        });
    },
    getFilteredInspections(data) {
        return httpService.post({
            url: `${baseUrl}InspectionDashboard/ADNOC/GetFilteredInspections/v2`,
            data: data
        });
    },
    getTMinSummary(data) {
        return httpService.post({
            url: `${baseUrl}InspectionDashboard/ADNOC/TMinSummary`,
            data: data
        });
    },
    getRemaingLifeSummary(data) {
        return httpService.post({
            url: `${baseUrl}InspectionDashboard/ADNOC/RemainingLifeSummary`,
            data: data
        });
    }
};

